export function formatNumber(num: number): string {
  // Utilise un espace comme séparateur de milliers au lieu de la barre oblique
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function formatDate(dateInput: string | Date): string {
  const date = typeof dateInput === 'string' 
    ? new Date(dateInput + 'T00:00:00')
    : dateInput;
  return date.toLocaleDateString('fr-FR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

export const format = {
  number: formatNumber,
  date: formatDate
};